import { useMediaQuery } from "@material-ui/core";
import React from "react";
import { BooleanInput, ReferenceInput, SelectInput } from "react-admin";
import SubmitFilters from "../components/filters/SubmitFilters";
import SearchInput from "../components/inputs/SearchInput";

const Filters = (props) => {
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	return (
		<SubmitFilters {...props}>
			<SearchInput source="q" alwaysOn fullWidth />
			<ReferenceInput
				source="role_ids"
				reference="roles"
				alwaysOn={!sm}
				fullWidth
				emptyText="ra.action.all"
			>
				<SelectInput optionText="name" />
			</ReferenceInput>
			<BooleanInput source="show_deal" alwaysOn={!sm} fullWidth />
		</SubmitFilters>
	);
};
export default Filters;
